var App = App || {};

App.ComponentCarousel = (function ($) {
    'use strict';
    function Carousel() {

        $(".component-carousel").each(function () {

            const carousel = $(this).find(".splide");

            var splide = new Splide(carousel[0], {
                type: 'loop',
                speed: 500,
                gap: '3rem'
            });

            splide.mount({});
        });
    }

    return {
        Carousel: Carousel
    };

})(jQuery);

$(function () {
    App.ComponentCarousel.Carousel();
});